import { render, staticRenderFns } from "./SnookerScheduleDialog.vue?vue&type=template&id=5b37a654&"
import script from "./SnookerScheduleDialog.vue?vue&type=script&lang=js&"
export * from "./SnookerScheduleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SnookerScheduleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports